import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function FlatTitle({ pageName }) {
  const location = useLocation();
  const currentPath = location.pathname;
  const pageLocation = currentPath.split("/").filter(Boolean).pop() || "Home";

  return (
    <div className="flat-title-page shop">
      <div className="item1 block-blur-1"></div>
      <div className="item2 block-blur-2"></div>
      <div className="item3 block-blur-3"></div>
      <div className="item4 block-blur-4"></div>
      <div className="section-container">
        <div className="row">
          <div className="col-12">
            <div className="heading">{pageName || pageLocation}</div>
            <ul className="breadcrumbs">
              <li className="icon-arrow-right relative">
                <Link to="/">Home</Link>
              </li>

              <li className="active">
                {/* <Link to={`#`}>{pageName || pageLocation}</Link> */}
                <p>{pageName || pageLocation}</p>
              </li>
              
              {/* {pageName !== "Quiz" &&<li className="active">
                <Link to={`#`}>{pageName || pageLocation}</Link>
              </li>} */}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}